import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { ROUTE_PATH } from 'lib/paths'
import { addNotification } from 'store/slices/notifications'
import {
  useAcceptOwnerTransferMutation,
  useRejectOwnerTransferMutation,
} from 'store/api/yay/group'

import ConfirmBoxBasic from 'components/ConfirmBoxBasic'

const ConfirmBoxGroupOwnerOffer = ({
  onClose,
  isActive,
  data,
}: {
  onClose: any
  isActive: boolean
  data: {
    groupId: number
  }
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [acceptOwnerTransfer, acceptOwnerTransferRes] =
    useAcceptOwnerTransferMutation()

  const [rejectOwnerTransfer, rejectOwnerTransferRes] =
    useRejectOwnerTransferMutation()

  return (
    <ConfirmBoxBasic
      title={t('confirm_box_group_owner_transfer.title')}
      onClose={onClose}
      onOk={() => {
        acceptOwnerTransfer({
          groupId: data?.groupId,
        }).then((res) => {
          if (res?.['data']?.result == 'success') {
            onClose()

            dispatch(
              addNotification({
                message: t('common.approved'),
              })
            )

            navigate(ROUTE_PATH.GROUP(data?.groupId))
          }
        })
      }}
      onCancel={async () => {
        const res = await rejectOwnerTransfer({
          groupId: data?.groupId,
        })

        if (res?.['data']?.result == 'success') {
          onClose()

          dispatch(
            addNotification({
              message: t('common.declined'),
            })
          )

          // force reload to clear offer action button
          setTimeout(() => {
            window.location.reload()
          }, 500)
        }
      }}
      isActive={isActive}
      loading={
        acceptOwnerTransferRes?.isLoading || rejectOwnerTransferRes?.isLoading
      }
      confirmButtonText={t('common.approve')}
      cancelText={t('common.decline')}
    />
  )
}

export default ConfirmBoxGroupOwnerOffer
